import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'objectKey',
})
export class ObjectKeyPipe implements PipeTransform {
  objectPair: any[] = [];
  transform(value: any) {
    Object.keys(value).forEach(key => {
      this.objectPair.push({
        key,
        value: value[key],
      });
    });
    return this.objectPair;
  }
}
